const tabsList = document.querySelector('[data-publishings-tabs-list]');
const tabs = document.querySelectorAll('[data-publishings-tab]');
const panels = document.querySelectorAll('[data-publishings-panel]');

enhanceBasicLinkListIntoTabPanel();

if (tabsList) {
    tabsList.addEventListener('click', (event) => {
        const clickedTab = event.target.closest('a');
        if (!clickedTab) {
            return;
        }
        event.preventDefault();
        switchPanel(clickedTab);
    });

    // Adding keyboard functionality
    tabsList.addEventListener('keydown', (event) => {
        switch (event.key) {
            case 'ArrowLeft':
                moveToPreviousTab();
                break;
            case 'ArrowRight':
                moveToNextTab();
                break;
        }
    });
}

function enhanceBasicLinkListIntoTabPanel() {
    if (tabsList) {
        tabsList.setAttribute('role', 'tablist');
        tabsList.querySelectorAll('li').forEach((listItem) => {
            listItem.setAttribute('role', 'presentation');
        });
    }

    tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        if (index === 0) {
            tab.setAttribute('aria-selected', 'true');
        } else {
            tab.setAttribute('tabindex', '-1');
            panels[index].style.display = 'none';
        }
    });

    panels.forEach((panel) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('tabindex', '0');
        panel.classList.remove('publishingsTabPanel__panelWrapper');
    });
}

function moveToPreviousTab() {
    const currentTab = document.activeElement;
    if (!currentTab.parentElement.previousElementSibling) {
        const lastTab = tabs[tabs.length - 1];
        switchPanel(lastTab);
    } else {
        const previousTab = currentTab.parentElement.previousElementSibling.querySelector('[data-publishings-tab]');
        switchPanel(previousTab);
    }
}

function moveToNextTab() {
    const currentTab = document.activeElement;
    if (!currentTab.parentElement.nextElementSibling) {
        const firstTab = tabs[0];
        switchPanel(firstTab);
    } else {
        const nextTab = currentTab.parentElement.nextElementSibling.querySelector('[data-publishings-tab]');
        switchPanel(nextTab);
    }
}

function switchPanel(newActiveTab) {
    const activePanelId = newActiveTab.getAttribute('href').split('#')[1];
    const activePanel = document.getElementById(activePanelId);

    tabs.forEach((tab) => {
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
        tab.classList.remove('publishingsTabPanel__tabTrigger--active');
    });

    panels.forEach((panel) => {
        panel.style.display = 'none';
    });

    newActiveTab.setAttribute('aria-selected', 'true');
    newActiveTab.setAttribute('tabindex', '0');
    newActiveTab.classList.add('publishingsTabPanel__tabTrigger--active');
    newActiveTab.focus();
    if (activePanel) {
        activePanel.style.display = 'block';
    }
}
